import React from 'react';

import { ThemedButton } from '../../../../shared/components/themed-button';
import { OverlayModal } from '../../../../shared/components/overlay-modal';
import DoneIcon from '../../../../assets/images/done.png';

import { useStyles } from './style';
import { useScreenSize } from '../../../../shared/hooks/use-screen-size';

interface Props {
  supplierName: string;
  isOpen: boolean;
  closeModal: () => void;
  addAnotherSupplier: () => void;
}

export const InviteSentModal: React.FC<Props> = ({ supplierName, isOpen, closeModal, addAnotherSupplier }) => {
  const classes = useStyles();
  const { isMobile } = useScreenSize();

  return (
    <OverlayModal boxClassName={classes.root} isOpen={isOpen} onClose={closeModal} animate={true} closeOnClickOutside={false}>
      <div className={classes.modalRoot}>
        <div className={classes.modalWrap}>
          <div className={classes.modalTitle}>
            Invite Sent to Supplier
          </div>
          <img src={DoneIcon} alt='Done' width={isMobile ? 80 : 139} height={isMobile ? 80 : 139} />
          <div className={classes.modalDesc}>
            <span className={classes.title}>We’ve sent the invite to {supplierName}</span>
            <span className={classes.subTitle}>Your supplier will receive an email with instructions to join Open Pantry and manage their products, prices and availability.</span>
            <div className={classes.tip}><strong>Tip:</strong> To speed up setup, we recommend you contact {supplierName} directly and ask them to complete their Open Pantry account setup and product list as soon as possible.</div>
          </div>
          
          <div className={classes.btnBox}>
            <ThemedButton width={220} buttonStyle='secondary' onClick={closeModal} title='Done' />
            <ThemedButton width={220} buttonStyle='primary' onClick={addAnotherSupplier} title='Add Another Supplier' />
          </div>
        </div>
      </div>
    </OverlayModal>
  );
};
